import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Browsers preserve scroll on SPA navigation, which lands you mid-page after a
 * click. Reset on pathname change — but not on search changes, so filtering a
 * listing doesn't yank you back to the top.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
